import axios from '../http/axios';

class Auth {
  constructor() {
    this.token = window.localStorage.getItem('token');
    let userData = window.localStorage.getItem('user');
    this.user = userData ? JSON.parse(userData) : null;
    this.validated = false;
    this.validationPromise = null;

    if (this.token) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;
    }
  }
  login = (token, user) => {
    if (!user.role || user.role !== 'admin') {
      this.logout();

      return false;
    }

    window.localStorage.setItem('token', token);
    window.localStorage.setItem('user', JSON.stringify(user));
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

    this.token = token;
    this.user = user;
    this.validated = true;
    this.validationPromise = null;

    return true;
  };
  check = () => {
    return !!this.token;
  };
  validate = () => {
    if (!this.check()) return Promise.resolve(false);
    if (this.validated) return Promise.resolve(true);
    if (this.validationPromise) return this.validationPromise;

    const token = this.token;
    const validationPromise = axios.get('/user')
      .then(({ data }) => {
        if (this.token !== token) return this.validated;
        if (!data.user || data.user.role !== 'admin') {
          this.logout();
          return false;
        }

        this.user = data.user;
        this.validated = true;
        window.localStorage.setItem('user', JSON.stringify(data.user));
        return true;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          if (this.token === token) this.logout();
          return false;
        }
        throw error;
      })
      .finally(() => {
        if (this.validationPromise === validationPromise) this.validationPromise = null;
      });

    this.validationPromise = validationPromise;
    return validationPromise;
  };
  logout = () => {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
    this.token = null;
    this.user = null;
    this.validated = false;
    this.validationPromise = null;
  };
}
export default new Auth();
